var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "food-donation",
    width: 16,
    height: 16,
    opacity: 0.672,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA7AAAAOwBeShxvQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAANfSURBVFiFrddLaF5FFAfwX2M08U2sqA0ohepCFCsqlgq+EFQQo2ANmmiJuvLRhS4UdwVdiAuFLsSFIC1IFeoj9RHBV9WFUBGJRRRRU1tRaU1QxPTt5+Kcm+/r9fvy3Rvzh8udM3Nm5j/nnDkzA6/jOYHT8RXGUr4WX2OlxUEPhvE2duMtaGAqFa5J+cWU16c8pj2Ox3EVJz8JEzne3NdTnbw+DOEFTOIAZvM/LSy3ATfh2Db9X8GN+Ba3YlfRUMUCE/ilxH5vDvY99pXafsJD6M9xbs7677A066ayrhKBBg5hq/DhsjYrXIb7kuzh7LMDF+bqG7i9Rb8WgQ9xfptJO2EltmXfffgzy2eUCRQx0IMBnJxyX8qFCTfhmxoEJsViHhFBekrW72mn3KjwjdWYvIxR4b5GqX4Kjd4UDgp/lTGovb/r4CU8ieWdFP7RsiVKeEIwX/s/ScwFXLmuFz/gXDwutlSBftyZ5db6E8RW2l0a8Gz8LoKuFoZxRGf/j6feoKO32B6x19eJnFBs1XdStxUdLVAI12smkKdErm5gI3rz+zzrduFTETcFyYP4RFilIc6PvjoElqfwUcpjKa9PeU3K72tuzctFCp7Osmz7IHVvq0Kg6llwUf43Yn+Wt2OFSFDbs25/6rT2mRdVCfyc/0tK9X/4b3K5tNRnUQhsxYwIuNF59EbxIP4WcbRoBH7DPZqBOdJGZyTbGrhbnJ6LRoCwwh0icW3KSQoMa/p+rbhlVUJvd5Wj8KpITps1T8wDIt0uSVKb6wxYl0BBYqREoiGss6VL35mW8qnUc0Ertmi6gzD7fJO/K5LVgNKiF0qAsMRqrNLd7A/gsywP4TR5AC7EBa34oqLeOlzdrqGbBU6sRac91uCZTo3dCDyMx0SE18WS7P9yyjsXQuAYcTpO4OIak1+A98TKD4s8sW0hBN4Ql9EbhL/HcS/OaqM7iLvEc2sHrhPH8mq81mmCbkE4KRLP/XhURPBQts2KdHtEvCmXtvT7FU/jec3Tc14CM2JPnyf2anGi7c0BnhXPrqvEs+pKcVldIXw9iy/FpWVcmP9Qaa7p/F8mroFniivcHN4UGa24nv2Fc+ZjL96AfV10CqzSvM4Vc2xoVRgQD8+d+BhXVBy4Dm4Rl5cfhYv6/wU7RQvxsMgNyAAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeal);
export default __webpack_public_path__ + "static/media/meal.f809762c.svg";
export { ForwardRef as ReactComponent };